import { UpdateVersionForceGroupItemArray } from './../../../../models/domain/update.version.force.group.item';
import { UserRolesService } from '../../../../services/user.roles.service';
import { LicenseManager } from '../../../../managers/License.manager';
import { LiveHubService } from './../../../../services/livehub.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { clientFilesFilter } from '../../../../pipes/filter.pipe';
import { ssApiService } from '../../../../services/ss-api.service';
import { UpdateClientSettingsItemArray } from '../../../../models/domain/update.client.settings.item';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'update-manager',
    templateUrl: './update.manager.component.html',
    styleUrls: ['./update.manager.component.scss']
})

export class LicenseUpdateManagerComponent implements OnInit, OnDestroy {
    IsBusy: boolean = false;

    @Input('licenseManager') licenseManager: LicenseManager;
    @Input('Subscriptions') Subscriptions;

    // Update Manager Stuff
    UpdateManagerOutputItems: Array<any> = new Array<any>();
    UpdateManagerFiles: Array<any> = new Array<any>();
    UpdateManagerInput: string;
    UpdateOverrideSelected: any;
    Settings: UpdateClientSettingsItemArray = new UpdateClientSettingsItemArray();

    FileProgressSubscription: Subscription;

    constructor(private liveHub: LiveHubService, private sweetAlert: SweetAlertService, private clientFilesFilter: clientFilesFilter, private api: ssApiService, public roles: UserRolesService) {
        /*
        this.FileProgressSubscription = liveHub.OnFileUploadProgress.subscribe(data =>             
        {
            console.log("Progress Received ---------------------");
            console.log("Speed: " + data.SpeedPerSecondBytesFormatted);
            console.log("Percentage: " + data.PercentageFormatted);
            console.log("Estimated Time Left: " + data.EstimatedTimeLeftFormatted);
            console.log("Total Size: " + data.TotalSizeFormatted);
            console.log("Total Transfered: " + data.ProcessedSizeFormatted);
        });
        */
    }

    ngOnDestroy(){
        if (this.FileProgressSubscription != null)
            this.FileProgressSubscription.unsubscribe();
    }

    ngOnInit() {
        // this.IsBusy = true;
        this.InitUpdaterSettings();
                
    }

    InitUpdaterSettings() {
        let disposable = this.api.GetUpdateClientSettings().subscribe(response => {
            this.Settings = response.Data;
            this.UpdateOverrideSelected = this.licenseManager.License().OverrideUpdaterClientSettings_ID ? this.licenseManager.License().OverrideUpdaterClientSettings_ID : null;
            disposable.unsubscribe();
        });
    }

    DefaultClientSettingsChanged(e) {
        this.UpdateOverrideSelected = Number(e);
        this.licenseManager.License().OverrideUpdaterClientSettings_ID = Number(e);
        this.licenseManager.Edited();
    }

    SubmitUpdateManagerInput() {
        this.UpdateManagerOutputItems.unshift({
            'DateTimeCreated' : new Date(),
            'Content' : 'This is an example of what the content from the data stream might look like. You can ignore this for now since it\'s just for testing.'
        });

        if (this.UpdateManagerFiles.length < 3) {
            this.UpdateManagerFiles.push({
                'DateTimeCreated' : new Date(),
                'FileName' : 'update.dat',
                'Progress' : 0,
                'FileSize' : 2048,
                'DownloadSpeed' : 12.85
            });
        }

        if (this.UpdateManagerFiles.length == 1) {
            setInterval(() => {
                this.UpdateManagerFiles.forEach(function(item) {
                    item.Progress++;
                });
            }, 500);
        }
    }

}
